import { Injectable } from '@angular/core';
import { CookieKey } from 'src/app/domain/enums/cookies.enum';

@Injectable({
  providedIn: 'root'
})
export class CookieService {

  setCookie(cookie: CookieKey, value: string, days = 30): void {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${cookie}=${value}; expires=${expires}; path=/; secure=true`;
  }

  getCookie(cookie: CookieKey): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + cookie + '=([^;]+)'));
    return match ? match[2] : null;
  }
}
